module.exports = __webpack_public_path__ + "static/media/check.7f895e35.svg";